module.exports = __webpack_public_path__ + "static/media/webhook.e44066d6.png";